import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSvgDirective } from '@app/directives/inline-svg';

import { FourOhFourRoutingModule } from './four-oh-four-routing.module';
import { FourOhFourComponent } from './four-oh-four.component';

@NgModule({
  exports: [FourOhFourComponent],
  imports: [CommonModule, FourOhFourRoutingModule, InlineSvgDirective, FourOhFourComponent]
})
export class FourOhFourModule {}
